import { Collapse, Text } from 'components';
import React from 'react';

const Instructions: React.FC = () => (
    <Collapse>
      <Collapse.Panel header="Instructions" key="1">
        <Text>
          1. First you must select the unprocessed version (retslisting) of the
          listing you want to trigger a RETS update for. The retslisting can be
          selected via its object id or its mls number + board (board is
          optional but is needed for narrowing when there are multiple listings
          with the same mls number). If the retslisting does not exist, this
          tool will not work until it is created but creation can be triggered
          manually via rets2. Click Find Listing to select the retslisting.
          <br />
          <br />
          2. If the retslisting was found, then its data will be displayed and
          you will be able to make updates to it if you want to simulate a
          change in feed data. Clicking submit will perform the updates you made
          if any and a RETS update for that retslisting will be triggered
          immediately but will be done in the background. You can also toggle
          View Updates to preview what changes will be made.
          <br />
          <br />
          3. Afterwards you can click Find Listing again to view the{' '}
          <kbd>status</kbd> of the updated rets listing. If the status is{' '}
          <kbd>PROCESSING</kbd>, the RETS update has not finished yet. If the
          status is <kbd>PROCESSED</kbd>, the RETS update has completed
          successfully. Any other status means that the RETS update has failed
          for some reason which or may not be reflected in its{' '}
          <kbd>errorReason</kbd>.
        </Text>
      </Collapse.Panel>
    </Collapse>
  );

export default Instructions;
